export const LICENSE_ISSUES_CONSTANTS = {
  REMEDIATION: {
    SUCCESS_MESSAGE: `Remediated ${0} issues successfully`
  }
};
